import React, {useCallback} from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css'; // Import des styles nécessaires
import useGridStore from '../../stores/GridStore';

const ResponsiveGridLayout = WidthProvider(Responsive);

function ReactGridLayout() {
  const { tabs, activeTabId, onLayoutChange, removeFromGrid , resetToDefaultLayout} = useGridStore();
  const activeTab = tabs.find(tab => tab.id === activeTabId);

  const handleLayoutChange = useCallback((layout) => {
    requestAnimationFrame(() => onLayoutChange(layout));
  }, [onLayoutChange]);
  if (!activeTab) return null; 

  const cleanTitle = (id) => {
    const baseId = id.split('-')[0];
    return baseId.replace(/_/g, ' ');
  };
  

  return (


    <ResponsiveGridLayout
      className="layout"
      layouts={{ lg: activeTab.layouts }}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
      rowHeight={90}
      onLayoutChange={handleLayoutChange} 
      draggableHandle=".drag-handle"
      draggableCancel=".no_drag"
    >
      {activeTab.layouts.map(layout => (
        <div key={layout.i} data-grid={layout} className='widget_container drag-handle'>
          <div className="widget_header">
            <h3 className='widget_title'>{cleanTitle(layout.i)}</h3>
            <button onClick={() => removeFromGrid(layout)} className="close_widget_button no_drag">
              X
            </button>
          </div>
      
          <WidgetContainer item={layout} />
        </div>
      ))}
    </ResponsiveGridLayout>

  );
}

export default ReactGridLayout;

const WidgetContainer = ({ item }) => {
  const Component = item.component;
  return <Component />;
};

